import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.mjs';

/* script */

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"1em","height":"1em","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M14.6667 4.00008C14.6667 3.26675 14.0667 2.66675 13.3333 2.66675H2.66666C1.93333 2.66675 1.33333 3.26675 1.33333 4.00008V12.0001C1.33333 12.7334 1.93333 13.3334 2.66666 13.3334H13.3333C14.0667 13.3334 14.6667 12.7334 14.6667 12.0001V4.00008ZM13.3333 4.00008L7.99999 7.33342L2.66666 4.00008H13.3333ZM13.3333 12.0001H2.66666V5.33341L7.99999 8.66675L13.3333 5.33341V12.0001Z","fill":"currentColor"}})])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    {},
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
